import { Base } from "./Base";
import { initBehaviors, destroyBehaviors } from "..";
import events from "../../constants/events";
import { dispatchEvent } from "../../utilities/customEvents";
import { getShopifyProductsByGlobalIds } from "../../utilities/getShopifyProductsByGlobalIds";
import compileProductCard from "../../utilities/compileProductCard";

import { relewiseRecommend } from "../../utilities/relewise";

export class RelewiseRecommendCarousel extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    const { productId } = this.refs;

    this.c2s = JSON.parse(this.element.dataset.c2s);
    this.currentVariantId = this.element.dataset.currentVariantId;
    this.firstSKU = this.element.dataset.currentVariantSku;
    this.collections = this.element.dataset.collectionIds.split(',');
    this.crossStoreProductId = this.element.dataset.crossStoreProductId;
    this.vendor = this.element.dataset.vendor;

    this.init();
  }

  init() {
    this.cacheLoadingMarkup();
    this.getRecommendedProducts();
  }

  cacheLoadingMarkup() {
    const { carouselWrapper } = this.refs;
    this.loadingMarkup = carouselWrapper.innerHTML;
  }

  displayLoadingMarkup() {
    const { carouselWrapper } = this.refs;
    carouselWrapper.innerHTML = this.loadingMarkup;
  }

  getRecommendedProducts() {
    const { carousel } = this.refs;
    const c2s = this.c2s;

    relewiseRecommend("ProductsViewedAfterViewingProductRequest", {
      crossStoreProductId: this.crossStoreProductId,
      variantId: this.firstSKU,
      c2s: c2s,
      collections: this.collections.filter(
        (collectionId) => collectionId !== window.mosmosh.collections.api
      ),
      vendor: this.vendor,
    })
      .then((response) => response.json())
      .then((json) => {
        if (json) {
          this.compileProductCards(
            getShopifyProductsByGlobalIds(
              this.applyDataModelling(json.recommendations)
            )
          );
        }
      })
      .catch((error) => {
        console.log(error);
        this.handleErrors();
      });

    destroyBehaviors(carousel);
    initBehaviors(carousel);
  }

  applyDataModelling(data) {
    const modeledData = [];

    data.forEach((entry) => {
      modeledData.push({
        crossStoreProductId: parseInt(entry.productId),
        variantId: parseInt(entry.variant.variantId),
      });
    });

    return modeledData;
  }

  compileProductCards(products) {
    const {
      productCardTemplate,
      productCardMediaItemTemplate,
      carousel,
      carouselWrapper,
    } = this.refs;

    const templates = {
      productCardTemplate,
      productCardMediaItemTemplate,
    };

    const settings = {
      hideTags: true,
      showPackshot: true,
      preselectURL: true,
    };

    carouselWrapper.innerHTML = "";

    for (const product of products) {
      carouselWrapper.innerHTML += `
            <div class="swiper-slide swiper-product-slide carousel__item carousel__item--4-of-8 carousel__item--2-of-8-md">
              ${compileProductCard(
                product,
                product.currentOrFirstVariant,
                templates,
                settings
              )}
            </div>
            `;
    }

    dispatchEvent(window, events.PRODUCT_IMAGES_UPDATED);

    //Destory before init, to re-init carousel
    requestAnimationFrame(() => {
      destroyBehaviors(carousel);
      initBehaviors(carousel);
    });
  }

  cleanup() {}
}
